import type { PropsWithChildren } from 'react'

import { Icon } from '@fv/client-components'

export const ExpirationNotice = ({ children }: PropsWithChildren) => {
  return (
    <div className="text-sm fa-width-auto">
      <Icon icon="hand-paper" className="text-fv-orange" />
      <span>{children}</span>
    </div>
  )
}
